<template>
  <v-btn class="text-capitalize" color="red accent-2 white--text">
    {{ $t("close") }}
  </v-btn>
</template>

<script>
export default {};
</script>

<style>
</style>